module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAADAs7DAsrG/srC/tra/s7PV1dW/srDU4DWeAAAAB3RSTlMA6KaIHGQGhTfW1wAAAHJJREFUSMdjGOaARbEcLxByACpyLCcARICK1AkpKgIqEiekqBCoqLwcj4PB8qOKRhWNKhpVNKqI+ooIF9HEFvaEqw3iKiB0AJFAFSNXUWk4lRQBweBRlCyOFmVmWBSZowd1MRZF4hixT64iTOuIc/jIAADktQUskTwUjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/download_icon_pc_default.png
// module id = grVd
// module chunks = 10